import { Graph } from "../WeightPrediction";
import React from "react";

export function WeightGoalGraph({ dataPoints, prediction }) {
  return (
    <div className="text-center mb-6 bg-white rounded-2xl shadow-sm ">
      <h2 className="text-xl font-bold text-gray-800 mb-4 pt-4">
        You can reach your goal of <br />
        <span className="text-green-500 text-3xl">
          {Math.abs(prediction.currentWeight - prediction.goalWeight).toFixed(
            0,
          )}{" "}
          kg
        </span>{" "}
        <span className="text-3xl">
          by{" "}
          {prediction.targetDate.toLocaleDateString("en-US", {
            month: "long",
            day: "numeric",
          })}
        </span>
      </h2>
      <div className="p-6">
        <Graph
          dataPoints={dataPoints}
          height="h-48"
          gradientColors={{
            primary: "#22c55e",
            secondary: "#3b82f6",
          }}
        />
      </div>
    </div>
  );
}
